// eslint-disable-next-line no-shadow
enum CardType {
  MASTER_CARD = 'mastercard',
  VISA = 'visa',
  AMERICAN_EXPRESS = 'amex',
  DINERS_CLUB = 'diners',
  DISCOVER = 'discover',
  EN_ROUTE = 'enroute',
  JCB = 'jcb',
  VOYAGER = 'voyager',
  HIPER_CARD = 'hipercard',
  AURA = 'aura',
  ELO = 'elo',
}
export default CardType;
